import React from 'react';
import {Typography} from '@mui/material';
import {formatBlockClassificationPrefix} from '../../../utils/documentHeaderMeta';

const MapRenderer = ({node, idx, inTable = false, inListItem = false, prefixText}) => {
    if (!node) return null;
    const key = `node-${idx}`;
    const attrs = node.attrs || {};
    const {snapshotThumbUrl, caption, title} = attrs;
    const getClassification = (n) => formatBlockClassificationPrefix(n?.attrs);

    return (
        <Typography key={key} component="div" sx={{mb: inTable ? 0 : 2}}>
            {prefixText && `${prefixText} `}
            {!inListItem && !prefixText && `(${getClassification(node)}) `}
            {snapshotThumbUrl ? (
                <img
                    src={snapshotThumbUrl}
                    alt={title || ''}
                    title={title || undefined}
                    style={{
                        maxWidth: '100%',
                        height: 'auto',
                        display: 'block',
                        border: '1px solid #cde'
                    }}
                />
            ) : (
                <Typography
                    component="div"
                    sx={{
                        border: '1px solid #cde',
                        borderRadius: 1,
                        bgcolor: '#f5f5f5',
                        color: 'text.secondary',
                        p: 2,
                        textAlign: 'center'
                    }}
                >
                    Map preview unavailable
                </Typography>
            )}
            <Typography variant="caption" component="div" sx={{mt: 0.5, color: 'text.secondary'}}>
                {caption}
            </Typography>
        </Typography>
    );
};

export default MapRenderer;
